import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

//
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
export default new Router({
	mode: 'history',
	base: '/',
	routes: [{
		path: '*',
		redirect: '/'
	}, {
		path: '/',
		name: 'PageView',
		redirect: '/',
		component: resolve => require(['@/view/PageView'], resolve),
		children: [{
			path: '/',
			name: 'home',
			component: resolve => require(['@/view/HomePage'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			}
		}, {
			path: '/page/singlepage/:id',
			name: 'singlepage',
			component: resolve => require(['@/view/singlepage'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/page/article/:id',
			name: 'article',
			component: resolve => require(['@/view/article'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/page/article_list/:id',
			name: 'article_list',
			component: resolve => require(['@/view/article_list'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: 'search',
			name: 'search',
			component: resolve => require(['@/view/search'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: 'searchthird/dafei',
			name: 'searchthird',
			component: resolve => require(['@/view/searchthird'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/page/showCoin',
			name: 'showCoin',
			component: resolve => require(['@/view/showCoin'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/page/agentList',
			name: 'agentList',
			component: resolve => require(['@/view/agentList'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/page/overseasAgency',
			name: 'overseasAgency',
			component: resolve => require(['@/view/overseasAgency'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			}, //
		}, {
			path: '/page/feedback',
			name: 'feedback',
			component: resolve => require(['@/view/feedback'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/search/score_count/:name',
			name: 'scoreCount',
			component: resolve => require(['@/view/scoreCount'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/user/search/score_count/:name',
			name: 'goodsTable',
			component: resolve => require(['@/view/goodsTable'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/page/applyinvoice',
			name: 'applyinvoice',
			component: resolve => require(['@/view/applyinvoice'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/k/:ratingCode',
			name: 'ratingResult',
			component: resolve => require(['@/view/ratingResult'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		},
		{
			path: '/p/:phoneNumber',
			name: 'privacyAgreement',
			component: resolve => require(['@/view/privacyAgreement'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		},
		{
			path: '/ratingReport',
			name: 'ratingReport',
			component: resolve => require(['@/view/ratingReport'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		},
		{
			path: '/activity/renminbibanbie1',
			name: 'renminbiPic',
			component: resolve => require(['@/view/renminbiPic'], resolve),
			meta: {
				title: '第一套人名币版别'
			},
		}, {
			path: '/activity/renminbibanbie2',
			name: 'renminbiPic',
			component: resolve => require(['@/view/renminbiPic'], resolve),
			meta: {
				title: '第二套人名币版别'
			},
		}, {
			path: '/activity/renminbibanbie3',
			name: 'renminbiPic',
			component: resolve => require(['@/view/renminbiPic'], resolve),
			meta: {
				title: '第三套人名币版别'
			},
		}, {
			path: '/activity/renminbibanbie4',
			name: 'renminbiPic',
			component: resolve => require(['@/view/renminbiPic'], resolve),
			meta: {
				title: '第四套人名币版别'
			},
		}, {
			path: '/k/:ratingCode/:chipUrl',
			name: 'ratingResult',
			component: resolve => require(['@/view/ratingResult'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/clear',
			name: 'clear',
			component: resolve => require(['@/view/clear'], resolve),
			meta: {
				title: '北京公博古钱币艺术品鉴定有限公司'
			},
		}, {
			path: '/weChatCode',
			name: 'weChatCode',
			component: resolve => require(['@/view/weChatCode'], resolve),
			meta: {
				title: '微信登陆'
			},
		}, {
			path: '/policy',
			name: 'policy',
			component: resolve => require(['@/view/policy'], resolve),
			meta: {
				title: '隐私政策'
			},
		}, {
			path: '/useragreement',
			name: 'useragreement',
			component: resolve => require(['@/view/useragreement'], resolve),
			meta: {
				title: '用户协议'
			},
		},]
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js